module.exports = __webpack_public_path__ + "static/media/whatsapp.4746f7cb.svg";